/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Amorim API v1
 * Amorim API v1 — Public-facing endpoints (CMS, authentication, authenticated user resources, reservations).
 *
 * **Authentication**
 *
 * - All requests require an `Api-Key` header.
 * - Endpoints that operate on the authenticated user additionally require `Authorization: Bearer <jwt>`.
 * OpenAPI spec version: v1
 */
import type {
  PreferenceCategoryValueDto,
  PreferenceDto,
  UpdatePreferenceCategoryValueRequest,
  UpsertPreferenceRequest
} from '../model';

import { customFetch } from '../../../custom-fetch.ts';

export type getMePreferencesV1Response200 = {
  data: PreferenceDto[]
  status: 200
}

export type getMePreferencesV1Response401 = {
  data: void
  status: 401
}

export type getMePreferencesV1ResponseSuccess = (getMePreferencesV1Response200) & {
  headers: Headers;
};
export type getMePreferencesV1ResponseError = (getMePreferencesV1Response401) & {
  headers: Headers;
};

export type getMePreferencesV1Response = (getMePreferencesV1ResponseSuccess | getMePreferencesV1ResponseError)

export const getGetMePreferencesV1Url = () => {




  return `/api/v1/me/preferences`
}

/**
 * Returns all active preferences for the authenticated user, ordered by category and subcategory.
 * @summary Get current user's preferences
 */
export const getMePreferencesV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getMePreferencesV1Response> => {

  return customFetch<getMePreferencesV1Response>(getGetMePreferencesV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type upsertMePreferenceV1Response200 = {
  data: PreferenceDto
  status: 200
}

export type upsertMePreferenceV1Response400 = {
  data: void
  status: 400
}

export type upsertMePreferenceV1Response401 = {
  data: void
  status: 401
}

export type upsertMePreferenceV1ResponseSuccess = (upsertMePreferenceV1Response200) & {
  headers: Headers;
};
export type upsertMePreferenceV1ResponseError = (upsertMePreferenceV1Response400 | upsertMePreferenceV1Response401) & {
  headers: Headers;
};

export type upsertMePreferenceV1Response = (upsertMePreferenceV1ResponseSuccess | upsertMePreferenceV1ResponseError)

export const getUpsertMePreferenceV1Url = () => {




  return `/api/v1/me/preferences`
}

/**
 * Creates or updates a preference. Matched by (CategoryNodeKey, SubcategoryNodeKey).
 * @summary Create or update a preference
 */
export const upsertMePreferenceV1 = async (upsertPreferenceRequest: UpsertPreferenceRequest, options?: Parameters<typeof customFetch>[1]): Promise<upsertMePreferenceV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<upsertMePreferenceV1Response>(getUpsertMePreferenceV1Url(),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(upsertPreferenceRequest)
  }
);}


export type deleteMePreferenceV1Response204 = {
  data: void
  status: 204
}

export type deleteMePreferenceV1Response401 = {
  data: void
  status: 401
}

export type deleteMePreferenceV1Response404 = {
  data: void
  status: 404
}

export type deleteMePreferenceV1ResponseSuccess = (deleteMePreferenceV1Response204) & {
  headers: Headers;
};
export type deleteMePreferenceV1ResponseError = (deleteMePreferenceV1Response401 | deleteMePreferenceV1Response404) & {
  headers: Headers;
};

export type deleteMePreferenceV1Response = (deleteMePreferenceV1ResponseSuccess | deleteMePreferenceV1ResponseError)

export const getDeleteMePreferenceV1Url = (id: string,) => {




  return `/api/v1/me/preferences/${id}`
}

/**
 * Marks a preference as inactive. The record is kept for audit and CRM sync purposes.
 * @summary Soft delete a preference
 */
export const deleteMePreferenceV1 = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<deleteMePreferenceV1Response> => {

  return customFetch<deleteMePreferenceV1Response>(getDeleteMePreferenceV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type getMePreferenceCategoryValuesV1Response200 = {
  data: PreferenceCategoryValueDto[]
  status: 200
}

export type getMePreferenceCategoryValuesV1Response401 = {
  data: void
  status: 401
}

export type getMePreferenceCategoryValuesV1ResponseSuccess = (getMePreferenceCategoryValuesV1Response200) & {
  headers: Headers;
};
export type getMePreferenceCategoryValuesV1ResponseError = (getMePreferenceCategoryValuesV1Response401) & {
  headers: Headers;
};

export type getMePreferenceCategoryValuesV1Response = (getMePreferenceCategoryValuesV1ResponseSuccess | getMePreferenceCategoryValuesV1ResponseError)

export const getGetMePreferenceCategoryValuesV1Url = () => {




  return `/api/v1/me/preferences/categories`
}

/**
 * Returns the free text the user wrote per interest category (Brands, EatAndDrink, Events, Stays, Massage). Categories never written are absent.
 * @summary Get the free text of each interest category
 */
export const getMePreferenceCategoryValuesV1 = async ( options?: Parameters<typeof customFetch>[1]): Promise<getMePreferenceCategoryValuesV1Response> => {

  return customFetch<getMePreferenceCategoryValuesV1Response>(getGetMePreferenceCategoryValuesV1Url(),
  {
    ...options,
    method: 'GET'


  }
);}


export type setMePreferenceCategoryValueV1Response200 = {
  data: PreferenceCategoryValueDto
  status: 200
}

export type setMePreferenceCategoryValueV1Response400 = {
  data: void
  status: 400
}

export type setMePreferenceCategoryValueV1Response401 = {
  data: void
  status: 401
}

export type setMePreferenceCategoryValueV1ResponseSuccess = (setMePreferenceCategoryValueV1Response200) & {
  headers: Headers;
};
export type setMePreferenceCategoryValueV1ResponseError = (setMePreferenceCategoryValueV1Response400 | setMePreferenceCategoryValueV1Response401) & {
  headers: Headers;
};

export type setMePreferenceCategoryValueV1Response = (setMePreferenceCategoryValueV1ResponseSuccess | setMePreferenceCategoryValueV1ResponseError)

export const getSetMePreferenceCategoryValueV1Url = (category: string,) => {




  return `/api/v1/me/preferences/categories/${category}/value`
}

/**
 * Saves the free text of a category (Brands, EatAndDrink, Events, Stays, Massage). Max 2000 characters; empty clears it.
 * @summary Save the free text of one interest category
 */
export const setMePreferenceCategoryValueV1 = async (category: string,
    updatePreferenceCategoryValueRequest: UpdatePreferenceCategoryValueRequest, options?: Parameters<typeof customFetch>[1]): Promise<setMePreferenceCategoryValueV1Response> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Array.isArray(h)) return Object.fromEntries(h);
    return h;
  };
return customFetch<setMePreferenceCategoryValueV1Response>(getSetMePreferenceCategoryValueV1Url(category),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePreferenceCategoryValueRequest)
  }
);}


